import React from "react";
import { Image, Responsive, Grid, Header } from "semantic-ui-react";
import { sliderArrowRight, sliderArrowLeft } from "../assets/Assets";
import Slider from "react-slick";
import { mainIp } from "../API/API";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";

export const typeOfPropertySelector = [
  {
    key: "home",
    value: "home",
    text: "Casa"
  },
  {
    key: "department",
    value: "department",
    text: "Departamento"
  }
];

class SliderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.dickref = React.createRef();
    this.slider = [];
  }

  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  renderWithoutSlider() {
    return (
      <div
        style={{
          overflow: "hidden"
        }}
      >
        <div className="marginBottom">
          <div
            style={{
              display: "flex"
            }}
          >
            <div>
              <Header
                as="h2"
                className="title"
                style={{
                  color: "#5594b7",
                  fontSize: "40px",
                  textAlign: "left"
                }}
              >
                Más propiedades
              </Header>
            </div>
          </div>
        </div>
        <div className="sliderNavContainer">
          {this.props.slider.map((data, index) => {
            let typeOfProperty = "";
            const foundTypeProperty = typeOfPropertySelector.find(
              typeProperty => {
                return typeProperty.value === data.typeOfProperty;
              }
            );
            if (foundTypeProperty !== undefined) {
              typeOfProperty = foundTypeProperty.text;
            }
            return (
              <div key={index}>
                <div>
                  <img
                    src={mainIp + data.thumbnail.result}
                    style={{
                      cursor: "pointer",
                      background: "url(" + mainIp + data.thumbnail.result + ")",
                      backgroundSize: "cover"
                    }}
                    onClick={() => {
                      this.props.push(data.url);
                      window.scroll({
                        top: document.getElementById("nav").offsetTop,
                        behavior: "auto"
                      });
                    }}
                    className="imageNavSlider"
                    width={700}
                    height={500}
                    alt={data.name}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "15px",
                    textAlign: "left",
                    color: "#023552"
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      marginTop: "10px"
                    }}
                  >
                    {typeOfProperty}
                  </p>
                  <Header
                    as="h2"
                    style={{
                      color: "#023552",
                      marginTop: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      this.props.push(data.url);
                      window.scroll({
                        top: document.getElementById("nav").offsetTop,
                        behavior: "auto"
                      });
                    }}
                  >
                    {data.name}
                  </Header>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderInDesktop() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true
    };

    return (
      <div
        align="center"
        style={{
          width: "100%"
        }}
      >
        <div className="marginBottom">
          <Grid>
            <Grid.Column width={14}>
              <Header
                as="h2"
                className="title"
                style={{
                  color: "#5594b7",
                  fontSize: "40px",
                  textAlign: "left"
                }}
              >
                Más propiedades
              </Header>
            </Grid.Column>
            <Grid.Column width={1}>
              <Image
                src={sliderArrowLeft}
                style={{ cursor: "pointer" }}
                width={30}
                height={30}
                onClick={this.previous}
              />
            </Grid.Column>
            <Grid.Column width={1}>
              <Image
                src={sliderArrowRight}
                style={{ cursor: "pointer" }}
                width={30}
                height={30}
                onClick={this.next}
              />
            </Grid.Column>
          </Grid>
        </div>

        <Slider ref={c => (this.slider = c)} {...settings}>
          {this.props.slider.map((data, index) => {
            let typeOfProperty = "";
            const foundTypeProperty = typeOfPropertySelector.find(
              typeProperty => {
                return typeProperty.value === data.typeOfProperty;
              }
            );
            if (foundTypeProperty !== undefined) {
              typeOfProperty = foundTypeProperty.text;
            }
            return (
              <div
                key={index}
                style={{
                  width: "18rem",
                  display: "flex",
                  justifyContent: "left",
                  alignSelf: "left",
                  alignContent: "left",
                  textAlign: "left",
                  marginRight: "3rem"
                }}
              >
                <div
                  style={{
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    this.props.push(data.url);
                    window.scroll({
                      top: document.getElementById("nav").offsetTop,
                      behavior: "auto"
                    });
                  }}
                >
                  <Image
                    src={mainIp + data.thumbnail.result}
                    style={{ width: "90%", height: "250px" }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "15px",
                    textAlign: "left",
                    color: "#023552"
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      marginTop: "10px"
                    }}
                  >
                    {typeOfProperty}
                  </p>
                  <Header
                    as="h2"
                    style={{
                      color: "#023552",
                      marginTop: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      this.props.push(data.url);
                      window.scroll({
                        top: document.getElementById("nav").offsetTop,
                        behavior: "auto"
                      });
                    }}
                  >
                    {data.name}
                  </Header>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  }

  renderInTablet() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true,
      fade: true
    };
    return (
      <div
        align="center"
        style={{
          width: "100%"
        }}
      >
        <div className="marginBottom">
          <Header
            as="h2"
            className="title"
            style={{
              color: "#5594b7",
              fontSize: "1.7rem",
              textAlign: "left"
            }}
          >
            Más propiedades
          </Header>
        </div>

        <Slider ref={c => (this.slider = c)} {...settings}>
          {this.props.slider.map((data, index) => {
            let typeOfProperty = "";
            const foundTypeProperty = typeOfPropertySelector.find(
              typeProperty => {
                return typeProperty.value === data.typeOfProperty;
              }
            );
            if (foundTypeProperty !== undefined) {
              typeOfProperty = foundTypeProperty.text;
            }

            return (
              <div
                key={index}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "left",
                  alignSelf: "left",
                  alignContent: "left",
                  textAlign: "left",
                  marginRight: "3rem"
                }}
                onClick={() => {}}
              >
                <div>
                  <Image
                    src={mainIp + data.thumbnail.result}
                    style={{ width: "100%", height: "250px" }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "15px",
                    textAlign: "left",
                    color: "#023552"
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      marginTop: "10px"
                    }}
                  >
                    {typeOfProperty}
                  </p>
                  <Header
                    as="h2"
                    style={{
                      color: "#023552",
                      marginTop: "8px"
                    }}
                  >
                    {data.name}
                  </Header>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  }

  renderInMobile() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: false,
      fade: true
    };
    return (
      <div
        align="center"
        style={{
          width: "100%"
        }}
      >
        <div className="marginBottom">
          <Header
            as="h2"
            className="title"
            style={{
              color: "#5594b7",
              fontSize: "1.7rem",
              textAlign: "left"
            }}
          >
            Más propiedades
          </Header>
        </div>

        <Slider ref={c => (this.slider = c)} {...settings}>
          {this.props.slider.map((data, index) => {
            let typeOfProperty = "";
            const foundTypeProperty = typeOfPropertySelector.find(
              typeProperty => {
                return typeProperty.value === data.typeOfProperty;
              }
            );
            if (foundTypeProperty !== undefined) {
              typeOfProperty = foundTypeProperty.text;
            }

            return (
              <div
                key={index}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "left",
                  alignSelf: "left",
                  alignContent: "left",
                  textAlign: "left",
                  marginRight: "3rem"
                }}
                onClick={() => {}}
              >
                <div>
                  <Image
                    src={mainIp + data.thumbnail.result}
                    style={{ width: "100%", height: "250px" }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "15px",
                    textAlign: "left",
                    color: "#023552"
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      marginTop: "10px"
                    }}
                  >
                    {typeOfProperty}
                  </p>
                  <Header
                    as="h2"
                    style={{
                      color: "#023552",
                      marginTop: "8px"
                    }}
                  >
                    {data.name}
                  </Header>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  }
  render() {
    if (this.props.slider.length < 4) {
      return this.renderWithoutSlider();
    } else {
      return (
        <div>
          <Responsive {...Responsive.onlyMobile}>
            {this.renderInMobile()}
          </Responsive>
          <Responsive {...Responsive.onlyTablet}>
            {this.renderInTablet()}
          </Responsive>
          <Responsive {...Responsive.onlyComputer}>
            {this.renderInDesktop()}
          </Responsive>
        </div>
      );
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    push: to => {
      dispatch(push(to));
    }
  };
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(SliderComponent)
);
